import C from './contact-channels88.js';
import r from './contact-channels176.js';
import _ from './contact-channels150.js';

function b(e,n,r$1){if(n=n||{},r$1=new C(r$1),r$1.selectNumberingPlan(e.country,e.countryCallingCode),r$1.hasTypes())return _(e,n,r$1.metadata)!==void 0;var l=n.v2?e.nationalNumber:e.phone;return r(l,r$1.nationalNumberPattern())}

export { b as default };
//# sourceMappingURL=contact-channels149.js.map
